import type { StyleLayer } from './utils/types'

export const layers_roads_smooth_bad: StyleLayer[] = [
  {
    id: 'smoothness-roads-bad',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'smoothness'], ['bad', 'very_bad'], true, false],
      [
        'match',
        ['get', 'road'],
        [
          'bicycle_road',
          'residential_priority_road',
          'primary',
          'residential',
          'trunk_link',
          'secondary_link',
          'tertiary_link',
          'service_uncategorized',
          'unspecified_road',
          'service_road',
          'service_alley',
          'unclassified',
          'tertiary',
          'secondary',
          'trunk',
          'primary_link',
          'cycleway_crossing',
          'living_street',
          'footway_crossing',
          'footway_sidewalk',
          'service_driveway',
          'service_emergency_access',
          'service_parking_aisle',
        ],
        true,
        false,
      ],
    ],
    paint: {
      'line-color': [
        'match',
        ['get', 'smoothness'],
        ['bad'],
        '#f90606',
        ['very_bad'],
        '#d8035c',
        ['intermediate'],
        '#faa00f',
        ['good'],
        '#b5ea2e',
        ['excellent'],
        '#37f644',
        '#000000',
      ],
      'line-dasharray': [1, 1],
      'line-opacity': ['interpolate', ['linear'], ['zoom'], 9.9, 0, 10, 0.1, 10.3, 0.9],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1, 14, 2, 16, 3],
    },
  },
]
